import React, { useState, useEffect } from 'react';
import { HotelType } from "../../../../backend/src/shared/types";
import HotelCard from './HotelCard';

type Props = {
  hotels: HotelType[];
};

const Dealsupto1000List: React.FC<Props> = ({ hotels }) => {
  const [displayedHotels, setDisplayedHotels] = useState<HotelType[]>([]);

  const updateDisplayedHotels = () => {
    const isLargeScreen = window.innerWidth >= 1536;
    const isMediumScreen = window.innerWidth >= 1024;

    const dealsupto1000Hotels = hotels.filter(hotel => hotel.pricePerNight >= 500 && hotel.pricePerNight <= 1000);

    if (isLargeScreen) {
      setDisplayedHotels(dealsupto1000Hotels.slice(0, 5));
    } else if (isMediumScreen) {
      setDisplayedHotels(dealsupto1000Hotels.slice(0, 4));
    } else {
      setDisplayedHotels(dealsupto1000Hotels.slice(0, 4));
    }
  };

  useEffect(() => {
    updateDisplayedHotels();
    window.addEventListener('resize', updateDisplayedHotels);

    return () => {
      window.removeEventListener('resize', updateDisplayedHotels);
    };
  }, [hotels]);

  return (
    <>
      {displayedHotels.length === 0 ? (
        <p>No affordable hotels available.</p>
      ) : (
        <>
          <div className="hidden md:flex justify-between gap-6">
            {displayedHotels.map((hotel) => (
              <HotelCard key={hotel._id} hotel={hotel} />
            ))}
          </div>
          <div className="flex md:hidden overflow-x-auto scrollbar-hide space-x-6 px-8 overflow-mob">
              {displayedHotels.map((hotel) => (
                <div key={hotel._id} className="min-w-[90%] flex-shrink-0">
                  <HotelCard hotel={hotel} />
                </div>
              ))}
          </div>
        </>
        
      )}
    </>
  );
};

export default Dealsupto1000List;
